import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-single-instance"
    }}>{`Getting Started with Single Instance`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#setup"
        }}>{`Setup`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#run-cezerin2"
        }}>{`Run Cezerin2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#run-cezerin2-admin"
        }}>{`Run Cezerin2 Admin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#run-cezerin2-store"
        }}>{`Run Cezerin2 Store`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#run-cezerin2-proxy"
        }}>{`Run Cezerin2 Proxy`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#docker-compose"
        }}>{`Docker Compose`}</a></li>
    </ul>
    <h2 {...{
      "id": "setup"
    }}>{`Setup`}</h2>
    <p>{`from the root directory execute`}</p>
    <pre><code parentName="pre" {...{}}>{`git clone https://github.com/Cezerin2/cezerin2-admin.git
`}</code></pre>
    <h2 {...{
      "id": "run-mongodb"
    }}>{`Run MongoDB`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run --name store-db -v /var/www/store-db:/data/db -d mongo:latest
`}</code></pre>
    <h2 {...{
      "id": "run-cezerin2"
    }}>{`Run cezerin2`}</h2>
    <ol>
      <li parentName="ol">{`Clone Cezerin2`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`git clone https://github.com/Cezerin2/cezerin2.git
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Build Cezerin2`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker build \\
-t cezerin2 \\
.
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Run Cezerin2`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run -d \\
--name cezerin2 \\
--link store-db:db \\
-p 3001:80 \\
-e DB_HOST=db \\
-e DB_PORT=27017 \\
-e DB_NAME=shop \\
-e DB_USER=user \\
-e DB_PASS=password \\
-e STORE_URL=http://www.exampe.com \\
-e API_BASE_URL=http://api.example.com/api/v1 \\
-e AJAX_BASE_URL=http://api.example.com/ajax \\
-e ASSETS_BASE_URL=http://api.example.com \\
-e ADMIN_BASE_URL=http://admin.example.com \\
-v /Users/LBus/development/Cezerin2/cezerin2/public/content:/var/www/cezerin2/public/content \\
cezerin2
`}</code></pre>
    <p>{`For local use change`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.exampe.com"
        }}>{`www.exampe.com`}</a>{` to localhost:3000`}</li>
      <li parentName="ul">{`api.example.com to localhost:3001`}</li>
      <li parentName="ul">{`admin.example.com to localhost:3002`}</li>
    </ul>
    <h2 {...{
      "id": "run-cezerin2-admin"
    }}>{`Run cezerin2 Admin`}</h2>
    <ol>
      <li parentName="ol">{`Clone Cezerin2 Admin`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`git clone https://github.com/Cezerin2/cezerin2-admin.git
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Build Cezerin2 Admin`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker build \\
-t cezerin2-admin \\
.
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Run Cezerin2 Admin`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run -d \\
--name cezerin2-admin \\
--link cezerin2:cezerin2 \\
-p 3002:80 \\
-e API_BASE_URL=http://api.example.com/api/v1
-e API_WEB_SOCKET_URL=ws://api.example.com
cezerin2-admin
`}</code></pre>
    <h2 {...{
      "id": "run-cezerin2-store"
    }}>{`Run Cezerin2 Store`}</h2>
    <ol>
      <li parentName="ol">{`Clone Cezerin2 Store`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`git clone https://github.com/Cezerin2/cezerin2-store.git
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Build cezerin2 Store`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker build \\
-t cezerin2-store \\
.
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Run Cezerin2 Store`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run -d \\
--name cezerin2-store \\
--link cezerin2:cezerin2 \\
-p 3002:80 \\
-e API_BASE_URL=http://api.example.com/api/v1 \\
-e AJAX_BASE_URL=http://api.example.com/ajax \\
cezerin2-store
`}</code></pre>
    <p>{`For local use change`}</p>
    <ul>
      <li parentName="ul">{`api.example.com to cezerin2`}</li>
    </ul>
    <h2 {...{
      "id": "build-run-cezerin3-proxy"
    }}>{`Build Run Cezerin3 Proxy`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create follow folder structure`}</p>
        <p parentName="li">{`cezerin2-admin # clone cezerin2-admin repo ├── nginx # nginx cezerin2-admin
config | ├── nginx.conf # nginx cezerin2-admin config │ └── default.conf #
cezerin2-admin dockerfile └── dockerfile # cezerin2-admin dockerfile`}</p>
      </li>
    </ol>
    <p><a parentName="p" {...{
        "href": "./cezerin2-proxy-dockerfile.md"
      }}>{`cezerin2-proxy dockerfile & docker-entrypoint`}</a></p>
    <p><a parentName="p" {...{
        "href": "./cezerin2-proxy-nginx.md"
      }}>{`cezerin2-proxy nginx`}</a></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Build Cezerin2 Proxy`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker build \\
-t cezerin2-proxy \\
.
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Run Cezerin2 Proxy`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker run -d \\
--name cezerin2-proxy \\
--link cezerin2:cezerin2 \\
--link cezerin2-admin:cezerin2-admin \\
--link cezerin2-store:cezerin2-store \\
-p 80:80 \\
-e DOMAIN=example.com \\
-e STORE_HOST=cezerin2-store \\
-e ADMIN_HOST=cezerin2-admin \\
-e API_HOST=cezerin2 \\
cezerin2-proxy
`}</code></pre>
    <h2 {...{
      "id": "docker-compose"
    }}>{`Docker Compose`}</h2>
    <p>{`setup project as: . ├── cezerin2 # clone cererin2 repo │ ├── dockerfile #
cezerin2 dockerfile │ └── docker-entrypoint.sh # cezerin2 docker-entrypoint.sh
├── cezerin2-admin # clone cezerin2-admin repo │ ├── nginx # nginx
cezerin2-admin config │ | ├── nginx.conf # nginx cezerin2-admin config │ │ └──
default.conf # cezerin2-admin dockerfile │ └── dockerfile # cezerin2-admin
dockerfile ├── cezerin2-store # clone cezerin2-store repo │ ├── dockerfile #
cezerin2-store dockerfile │ └── docker-entrypoint.sh # cezerin2-store
docker-entrypoint.sh ├── proxy # New folder for proxy │ └── dockerfile # proxy
dockerfile └── docker-compose.yml # Tools and utilities`}</p>
    <p><a parentName="p" {...{
        "href": "./cezerin2-docker-compose.md"
      }}>{`cezerin2 docker-compose`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      